"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCookiesDisabled = exports.getSubdomain = exports.getScreenSize = exports.getScreenWidth = exports.getScreenHeight = exports.getScreenOrientation = exports.getScreenColorDepth = exports.getPreferredLanguage = exports.getOperatingSystem = exports.getName = exports.getDomain = exports.getDeviceType = exports.getCurrentUrl = exports.getBrowserSize = exports.getBrowserWidth = exports.getBrowserHeight = void 0;
// import {OS, UAParser} from "ua-parser-js";
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var firefly_constants_1 = __importDefault(require("./constants/firefly-constants"));
function getDimensions(width, height) {
    var result = '';
    if (firefly_utilities_helper_ts_1.isNumber(width) && firefly_utilities_helper_ts_1.isNumber(height)) {
        result = width.toString() + " x " + height.toString();
    }
    return result;
}
function getBrowserHeight() {
    return window.innerHeight;
}
exports.getBrowserHeight = getBrowserHeight;
function getBrowserWidth() {
    return window.innerWidth;
}
exports.getBrowserWidth = getBrowserWidth;
function getBrowserSize() {
    var width = getBrowserWidth();
    var height = getBrowserHeight();
    return getDimensions(width, height);
}
exports.getBrowserSize = getBrowserSize;
function getCurrentUrl() {
    return document.URL;
}
exports.getCurrentUrl = getCurrentUrl;
function getDeviceType() {
    return navigator.platform;
}
exports.getDeviceType = getDeviceType;
function getDomain() {
    return window.location.hostname;
}
exports.getDomain = getDomain;
function getName() {
    return navigator.userAgent;
}
exports.getName = getName;
/* --- Update by Praxis team : Start --- */
// export function getOperatingSystem(): OS {
//         return UAParser.OS;
// }
function getOperatingSystem() {
    var OSName = "";
    if (navigator.userAgent.indexOf("Win") !== -1)
        OSName = "Windows";
    if (navigator.userAgent.indexOf("Mac") !== -1)
        OSName = "Mac OS";
    if (navigator.userAgent.indexOf("Linux") !== -1)
        OSName = "Linux";
    if (navigator.userAgent.indexOf("Android") !== -1)
        OSName = "Android";
    if (navigator.userAgent.indexOf("like Mac") !== -1)
        OSName = "iOS";
    return OSName;
}
exports.getOperatingSystem = getOperatingSystem;
/* --- Update by Praxis team : End --- */
function getPreferredLanguage() {
    var preferredLanguage;
    /* istanbul ignore next */
    if (firefly_utilities_helper_ts_1.isArray(navigator.languages) && navigator.languages.length !== 0) {
        /* istanbul ignore next */
        preferredLanguage = navigator.languages[0];
    }
    else {
        /* istanbul ignore next */
        preferredLanguage = navigator.language; //|| navigator['userLanguage'];
    }
    return preferredLanguage;
}
exports.getPreferredLanguage = getPreferredLanguage;
function getScreenColorDepth() {
    var result = "";
    /* istanbul ignore next */
    if (firefly_utilities_helper_ts_1.isNumber(screen.colorDepth)) {
        /* istanbul ignore next */
        result = screen.colorDepth.toString();
    }
    return result;
}
exports.getScreenColorDepth = getScreenColorDepth;
function getScreenOrientation() {
    var screenOrientation = "";
    var windowHeight = getBrowserHeight();
    var windowWidth = getBrowserWidth();
    if (firefly_utilities_helper_ts_1.isNumber(windowHeight) && firefly_utilities_helper_ts_1.isNumber(windowWidth)) {
        if (windowHeight > windowWidth) {
            screenOrientation = firefly_constants_1.default.SO_PORTRAIT;
        }
        else if (windowHeight < windowWidth) {
            screenOrientation = firefly_constants_1.default.SO_LANDSCAPE;
        }
        else {
            screenOrientation = firefly_constants_1.default.SO_SQUARE;
        }
    }
    return screenOrientation;
}
exports.getScreenOrientation = getScreenOrientation;
function getScreenHeight() {
    return screen.height;
}
exports.getScreenHeight = getScreenHeight;
function getScreenWidth() {
    return screen.width;
}
exports.getScreenWidth = getScreenWidth;
function getScreenSize() {
    var width = getScreenWidth();
    var height = getScreenHeight();
    return getDimensions(width, height);
}
exports.getScreenSize = getScreenSize;
function getSubdomain() {
    var domain, subdomain = "";
    domain = getDomain();
    /* istanbul ignore next  */
    if (firefly_utilities_helper_ts_1.isString(domain)) {
        /* istanbul ignore next  */
        if (domain.indexOf('.') !== -1) {
            subdomain = domain.split('.')[0];
        }
    }
    return subdomain;
}
exports.getSubdomain = getSubdomain;
function isCookiesDisabled() {
    return !navigator.cookieEnabled;
}
exports.isCookiesDisabled = isCookiesDisabled;
